import { logout } from "./authService";

const createAuthHeaders = (context) => {
  return new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${context.user.get.jwt}`, /// we no longer need to do anything manually
  });
};

const verifyHttpStatus = (httpStatus, context) => {
  if (httpStatus === 401) {
    logout(context);
    return;
  }

  return httpStatus;
};

export const createQueryParamsFromFilters = (filters) => {
  // Create the query params from incoming filters object
  let queryParams = '';
  
    for (let property in filters) {
    if (filters[property] !== null || filters[property] !== undefined || filters[property] !== '') {
        queryParams = queryParams.concat(`${encodeURIComponent(property)}=${encodeURIComponent(filters[property])}&`);
    }
  }

  return queryParams;
};

export const getKjosandiForElection = async (kennitala, context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isError = false;

  const url = `/api/kjorskra/${context.activeKosning.get.id}/${kennitala}`;

  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context),
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isError = true;
    }
  } catch (err) {
    isError = true;
  }

  return { data, httpStatus, isError };
};

export const getAtkvaediById = async (id, context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `api/atkvaedi/${id}`;

  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const getAtkvaediByKennitala = async (kennitala, context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `/api/atkvaedi/kennitala/${kennitala}`;

  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
      console.log(data)
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const getAtkvaediByKosning = async (kosningId, context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `/api/atkvaedi/kosning/${kosningId}`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const getLatestAtkvaediByKosning = async (kosningId, filters, context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};
  let queryParams = createQueryParamsFromFilters(filters);

  const url = `/api/atkvaedi/kosning/${kosningId}/latest?${queryParams}`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const getAtkvaediCounts = async (kosningId, filters, context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};
  let queryParams = createQueryParamsFromFilters(filters);

  const url = `/api/tolfraedi/atkvaedi/counts/${kosningId}?${queryParams}`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const getAtkvaediSummary = async (kosningId, filters, context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};
  let queryParams = createQueryParamsFromFilters(filters);

  const url = `/api/tolfraedi/atkvaedi/summary/${kosningId}?${queryParams}`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const postAtkvaedi = async (payload, context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isError = false;
  let error = {};

  const url = "/api/atkvaedi";

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: createAuthHeaders(context),
      body: JSON.stringify(payload)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isError = true;
      error = await response.json(); // Get the error
    }
  } catch (err) {
    isError = true;
    error = err;
  }

  return { data, httpStatus, isError, error };
};

export const putAtkvaedi = async (id, payload, context) => {
  let httpStatus = 0;
  let isError = false;
  let error = {};

  const url = `/api/atkvaedi/${id}`;

  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: createAuthHeaders(context),
      body: JSON.stringify(payload)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      // No response, only success code
    } else {
      isError = true;
      error = await response.json();
    }
  } catch (err) {
    isError = true;
    error = err;
  }

  return { httpStatus, isError, error };
};

export const getOpnarKosningar = async (context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `/api/kosning/opnar`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
        data = await response.json();

    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const getVaentanlegarKosningar = async (context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `/api/kosning/vaentanlegar`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const getKosningarThatHaveAtkvaedi = async (context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `/api/kosning/hefur-atkvaedi`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const getOpnarKosningarInStyring = async (context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `/api/styring/kosning/opnar`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const postKosningStyring = async (payload, context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = "/api/styring/kosning";

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: createAuthHeaders(context),
      body: JSON.stringify(payload)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const putKosningStyring = async (id, payload, context) => {
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `/api/styring/kosning/${id}`;

  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: createAuthHeaders(context),
      body: JSON.stringify(payload)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      // No response, only success code
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { httpStatus, isSuccess, error };
};

export const getEmbaetti = async (context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `/api/embaetti`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const getSveitarfelog = async (context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `/api/options/sveitarfelog`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const getKjordaemi = async (context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `/api/options/kjordaemi`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};

export const getKjorstadir = async (context, initialData) => {
  let data = initialData;
  let httpStatus = 0;
  let isSuccess = true;
  let error = {};

  const url = `/api/options/kjorstadir`;
  try {
    const response = await fetch(url, {
      headers: createAuthHeaders(context)
    });

    httpStatus = verifyHttpStatus(response.status, context);

    if (response.ok) {
      data = await response.json();
    } else {
      isSuccess = false;
      error = await response.json();
    }
  } catch (err) {
    isSuccess = false;
    error = err;
  }

  return { data, httpStatus, isSuccess, error };
};